<template>
	<div class="hstack gap-3 align-items-center">
		<UserCommonImage :src="user?.avatar_url" size="md" rounded="3" :border="true" class="mx-auto" />
		<div class="flex-fill lh-sm text-limit">
			<div class="text-md text-truncate fw-bold">{{ user?.name }}</div>
			<div class="text-sm text-truncate text-muted hstack gap-1" v-if="subtitle" v-html="subtitle"></div>
			<div class="text-sm text-truncate text-muted hstack gap-1" v-if="balance"><b>Balance:</b> {{ vueNumberFormat(balance.amount, { suffix: ` ${balance.currency}`, precision: 2 }) }}</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			user: Object,
			balance: Object,
			subtitle: {
				type: String,
				default: null
			}
		}
	}
</script>